import { request } from '../gonfalon';

export type SettingsPrivateResponse = Readonly<{
  slackWebHookPlanChanges: string;
  relatedIdAccountSearchEnabled?: boolean;
}>;

export const getSettingsPrivate = () =>
  request<SettingsPrivateResponse>({
    method: 'GET',
    url: '/private/settings/vital',
  });
